import React from 'react';
import PropTypes from 'prop-types';
import { TriangleCloseIcon } from './icons/TriangleCloseIcon';
import { TriangleOpenIcon } from './icons/TriangleOpenIcon';


/* This is an expansion panel. This component provides the expansion bar and the open/close
   icon. It is upto the user of this component to render something, like a table, under the
   the expansion bar itself. */ 
export const ExpansionPanel = (props) => {

    // Fired when user clicks on the arrow icon to the left of the expansion panel bar.
    // Parent should take of toggling state of arrow to either open or close and then
    // executing associated business logic.
   
    /* tells component below whether to display open icon or close icon */
    let iconOpen  = props.open;

    // Return  JSX
    return (
        <div>
            <div className="expansion-panel-container">
                <div className="expansion-panel">
                        {(iconOpen)
                            ? (<div onClick={props.onClickHandler}><TriangleOpenIcon  /></div>)
                            : (<div onClick={props.onClickHandler}><TriangleCloseIcon /></div>)
                        }
                    <div className="expansion-panel-label">{props.text}</div>
                </div>
            </div>
        </div>
    )
}

ExpansionPanel.propTypes = {
    onClickHandler: PropTypes.func,
    text:           PropTypes.string,
    open:           PropTypes.bool  
};


// WEBPACK FOOTER //
// ./src/components/ExpansionPanel.js